export class SignatureLabel {
    xcoordinate!: number;
    ycoordinate!: number;
    height!: number;
    width!: number;
    pageIndex!: number;
    stampImage!: string;
}
